import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-add-product-packaging-ratio',
  templateUrl: './add-product-packaging-ratio.component.html',
  styleUrls: ['./add-product-packaging-ratio.component.scss'],
})
export class AddProductPackagingRatioComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  productPackagingData: any;
  productPackagingForm!: FormGroup;
  productPackagingAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  sectorIdentifierList: any;
  regionList: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  selectIdentifier: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveProductPackageEvent = new EventEmitter<any>();

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private administratorService: AdministratorService
  ) {
    this.productPackagingData =
      this.modal?.modalService?.config?.initialState?.['productPackageData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown =
      this.modalLabel == 'Review product package ratio detail' ? true : false;

    const newSectorIdentifier = this.productPackagingData.sectorIdentifierItems;

    this.sectorIdentifierList = newSectorIdentifier;

    const placeHolderRegion = {
      description: '-- Select Region --',
    };
    const newRegionlist = [placeHolderRegion].concat(this.productPackagingData.regionItems);
    this.regionList = newRegionlist;
    this.regionData = newRegionlist;
    this.indicatorList = this.productPackagingData.indicatiorList;

    this.getRegionData();
    this.getSelectIdentifierData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.productPackagingData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.productPackagingForm = new FormGroup(form);
    this.productPackagingAddEditForm = this.formBuilder.group({
      sectorIdentifier: [null, Validators.required],
      region: [null, Validators.required],
    });
    this.setFormData();
  }

  onChange(value: any) {
    this.productPackagingAddEditForm.controls['region'].reset();
    if (!!value?.id) {
      this.administratorService.GetMaterialRegions(value.id).subscribe((data: any) => {
        this.regionData = data.data;
      });
    } else {
      this.regionData = [];
    }
  }

  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.productPackagingData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }

  async getSelectIdentifierData() {
    await this.sectorIdentifierList.map((item: any) => {
      if (item.id == this.productPackagingData.sectorIdentifierId) {
        return (this.selectIdentifier = item);
      }
    });
  }

  setFormData() {
    this.productPackagingAddEditForm.patchValue({
      region: this.selectRegion,
      sectorIdentifier: this.selectIdentifier,
    });
  }

  onSave() {
    this.submitted = true;
    if (
      (this.productPackagingAddEditForm.controls['region'].value?.name == '' ||
        !this.productPackagingAddEditForm.controls['region'].value?.name) &&
      this.productPackagingAddEditForm.controls['sectorIdentifier'].value?.name
    ) {
      return;
    }
    if (
      this.productPackagingAddEditForm.status == 'VALID' &&
      this.productPackagingForm.status == 'VALID'
    ) {
      const entires = Object.entries(this.productPackagingForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.productPackagingData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const materialPayload = {
        regionId:
          this.productPackagingAddEditForm.controls['region'].value?.id ||
          this.productPackagingData.regionId,
        sectorIdentifierId:
          this.productPackagingAddEditForm.controls['sectorIdentifier'].value.id ||
          this.productPackagingAddEditForm.controls['sectorIdentifier'].value,
        indicatiorList: resultArray,
      };
      this.saveProductPackageEvent.emit(materialPayload);
      this.onClose();
    }
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
}
